//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";
import { Breadcrumb, Menu } from "semantic-ui-react";
import { jsx as _jsx } from "react/jsx-runtime";
const ApplicationBreadcrumb = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(Menu.Item, {
    id: "breadcrumb",
    header: true,
    "data-sentry-element": "unknown",
    "data-sentry-component": "ApplicationBreadcrumb",
    "data-sentry-source-file": "ApplicationBreadcrumb.tsx",
    children: /*#__PURE__*/_jsx(Breadcrumb, {
      "data-sentry-element": "Breadcrumb",
      "data-sentry-source-file": "ApplicationBreadcrumb.tsx",
      children: children
    })
  });
};
export default ApplicationBreadcrumb;